import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3f859f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Watch in ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 2D ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 3D ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Coming Soon... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_h2 = _resolveComponent("n-h2")!
  const _component_n_gi = _resolveComponent("n-gi")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_global_currency_icon = _resolveComponent("global-currency-icon")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_n_card = _resolveComponent("n-card")!

  return (_ctx.race.participants.length)
    ? (_openBlock(), _createBlock(_component_n_card, {
        key: 0,
        class: _normalizeClass(["live-race", `cover-${_ctx.coverIndex}`]),
        hoverable: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_n_space, {
            justify: "right",
            align: "center"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_n_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    onClick: _ctx.watchRace2D,
                    ghost: "",
                    type: "info",
                    class: "thick-text"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_n_button, {
                    onClick: _ctx.watchRace3D,
                    ghost: "",
                    type: "primary",
                    class: "thick-text"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_n_space, { vertical: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_n_grid, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_gi, { span: "8" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_h2, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_text, {
                            class: "live-race__title text-shiny",
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.race.name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_gi, {
                    span: "3",
                    offset: "1"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_n_space, {
                          vertical: "",
                          justify: "right"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_tag, { style: {"margin":"0","width":"100%","justify-content":"center"} }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.race.arena.distanceType()), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_n_tag, {
                              type: "success",
                              style: {"margin":"0","width":"100%","justify-content":"center"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_global_currency_icon, {
                                  name: _ctx.raceCurrencyName,
                                  size: 12,
                                  style: {"margin-right":".25rem"}
                                }, null, 8, ["name"]),
                                _createTextVNode(_toDisplayString(_ctx.formatNumberDecimals(_ctx.race.participants.length * Number(_ctx.eth.utils.formatEther(_ctx.race.entryFee)))), 1)
                              ]),
                              _: 1
                            }),
                            (_ctx.exchangeRatesAvailable && _ctx.exchangeRates[_ctx.race.entryFeeCurrency])
                              ? (_openBlock(), _createBlock(_component_n_tag, {
                                  key: 0,
                                  type: "info",
                                  style: {"margin":"0","width":"100%","justify-content":"center"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_global_currency_icon, {
                                      name: "USD",
                                      size: 12,
                                      style: {"margin-right":".25rem"}
                                    }),
                                    _createTextVNode(_toDisplayString(_ctx.convertToUSD(_ctx.formatNumberDecimals(_ctx.race.participants.length * Number(_ctx.eth.utils.formatEther(_ctx.race.entryFee))), false, _ctx.race.entryFeeCurrency)), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]))
    : (_openBlock(), _createBlock(_component_n_card, {
        key: 1,
        class: _normalizeClass(["live-race", `secondary-cover-${_ctx.coverIndex}`]),
        hoverable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_space, { vertical: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_n_h2, null, {
                default: _withCtx(() => [
                  _createVNode(_component_n_text, {
                    class: "live-race__title",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]))
}